import React from 'react';
import {
    BarChart,
    Bar,
    LabelList,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';

const AttendanceLabel = ({ x, y, width, payload }) => {
    if (!payload) {
        return null;
    }

    return (
        <text
            x={x + (width / 2)}
            y={y - 8}
            fill="#374151"
            textAnchor="middle"
            fontSize={11}
            fontWeight={600}
        >
            {`${payload.attendance}/${payload.totalMembers}`}
        </text>
    );
};

const AttendanceTrendChart = ({ data, showCounts }) => {
    if (!data || data.length === 0) {
        return (
            <div className="h-full flex items-center justify-center text-gray-400">
                No data available
            </div>
        );
    }

    // Calculate attendance percentage for each week
    const chartData = data.map(item => ({
        ...item,
        attendancePercent: item.totalMembers > 0
            ? Math.round((item.attendance / item.totalMembers) * 100)
            : 0
    }));

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={chartData}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                <XAxis
                    dataKey="week"
                    tick={{ fontSize: 12, fill: '#6B7280' }}
                    tickLine={{ stroke: '#E5E7EB' }}
                />
                <YAxis
                    tick={{ fontSize: 12, fill: '#6B7280' }}
                    tickLine={{ stroke: '#E5E7EB' }}
                    domain={[0, 100]}
                    tickFormatter={(value) => `${value}%`}
                />
                <Tooltip
                    contentStyle={{
                        backgroundColor: '#fff',
                        border: '1px solid #E5E7EB',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }}
                    formatter={(value, name) => {
                        if (name === 'Attendance %') return [`${value}%`, name];
                        return [value, name];
                    }}
                    labelFormatter={(label, tooltipPayload) => {
                        const current = tooltipPayload && tooltipPayload[0] ? tooltipPayload[0].payload : null;
                        if (!current) return label;
                        return `${label} - Attendance: ${current.attendance}/${current.totalMembers}`;
                    }}
                />
                <Legend />
                <Bar
                    dataKey="attendancePercent"
                    name="Attendance %"
                    fill="#22C55E"
                    radius={[4, 4, 0, 0]}
                >
                    {showCounts && <LabelList dataKey="attendancePercent" content={<AttendanceLabel />} />}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

AttendanceTrendChart.defaultProps = {
    showCounts: false,
};

export default AttendanceTrendChart;
